import React, { useState } from 'react';
import logo from '../../Assets/img/logo.png';
import { useNavigate } from 'react-router-dom';
import Api from '../../component/Api';
import StudentTemplate from '../../component/StudentTemplate';
import { ToastContainer, toast } from 'react-toastify';
import useAuth from '../../component/useAuth';


const StudentHelp = () => {
  const navigate = useNavigate();
  const isAuth = useAuth();
  const { http } = Api();
  if (isAuth === false) {
    navigate("/")
  }

  return (
    <>
      <StudentTemplate>
        <ToastContainer />

        <div className="container-fluid bg-light py-5">
          <div className="container">
            <div className="card shadow-sm mobile">
              <div className="infostyle bg-primary text-white" style={{}}>
                <h3 className="mb-0 mobile">MGU UGP - Instructions for Student</h3>
              </div>
              <div className="card-body mobile">
                <div className="accordion mobile" id="instructionsAccordion">
                  <InstructionItem
                    id="E-CopyRequestUserGuide"
                    title="1. E-Copy Request User Guide"
                    content={
                      <a href="https://ugpapi.mgu.ac.in/ugp/docs/E_Copy_Request-USER_GUIDE__3_.pdf" target="_blank" rel="noopener noreferrer">
                        Click here to view E-Copy Request Guide
                      </a>
                    }
                  />

                  {/* <InstructionItem
                    id="login"
                    title="2. How do I log in to the student portal?"
                    content={
                      <ol>
                        <li>Select the "Sign Up" option.</li>
                        <li>Enter your APAAR number, Aadhaar number, and date of birth.</li>
                        <li>You will receive an email with an option to set up a password.</li>
                        <li>Check your email and follow the instructions to create a password.</li>
                        <li>Once your password is set, log in using your APAAR ID and the newly created password.</li>
                      </ol>
                    }
                  />

                  <InstructionItem
                    id="resetPassword"
                    title="3. How do I reset my password if I forget it?"
                    content={
                      <ol>
                        <li>On the login page, click "Forgot Password".</li>
                        <li>Enter your APAAR number and Email ID, and a password reset link will be sent to your email.</li>
                      </ol>
                    }
                  />

                  <InstructionItem
                    id="noAPAAR"
                    title="4. How can I log in if I didn't provide my APAAR ID during the admission process?"
                    content={
                      <ol>


                        <li>Select "Sign Up" option.</li>
                        <li>You can log in using the format: Start with '9999' followed by your CAP ID. For example, if your CAP ID is 23456123, your temporary login ID will be 999923456123.</li>
                        <li>Enter the temporary login ID instead of the APAAR ID.</li>
                        <li>Enter Aadhaar number and DOB to proceed with login.</li>
                        <li>After obtaining your APAAR ID, use only the APAAR ID for login.</li>

                      </ol>
                    }
                  />

                  <InstructionItem
                    id="noAadhaar"
                    title="5. How can I log in if I don't have an Aadhaar Number?"
                    content={
                      <ul>
                        <li>Kindly contact your College Principal for assistance.</li>
                      </ul>
                    }
                  />

                  <InstructionItem
                    id="emailNotReceived"
                    title="6. What should I do if my email is registered but I haven’t received the mail to set my password?"
                    content={
                      <ul>
                        <li>Check your Spam or Junk folder.</li>
                        <li>If still not found, verify your email address or contact your Senior Faculty Advisor or Nodal Officer (MGU-UGP) for assistance.</li>
                      </ul>
                    }
                  />  */}

                  <InstructionItem
                    className='mobile'
                    id="changeEmailAddress"
                    title="2. How do I change my registered email address?"
                    content={
                      <ul>
                        <li className='mobile'>Contact your college administration to make changes through your Senior Faculty Advisor or Nodal Officer.</li>
                      </ul>
                    }
                  />

                  <InstructionItem
                    className='mobile'
                    id="courseRegistration"
                    title="3. How do I register courses once logged in?"
                    content={
                      <ul>
                        <li className='mobile'>After logging in, navigate to the 'Course Selection' section. Select the courses you have enrolled in, and follow the steps to complete your registration.</li>
                      </ul>
                    }
                  />

                  <InstructionItem
                    className='mobile'
                    id="portalIssues"
                    title="4. Whom should I contact if I face any issues with the portal?"
                    content={
                      <ul>
                        <li className='mobile'>For login or registration-related issues, contact your Senior Faculty Advisor or Nodal Officer (MGU-UGP) for guidance.</li>
                      </ul>
                    }
                  />

                  {/* <InstructionItem
                    className='mobile'
                    id="loginIssues"
                    title="5. Common Login Issues:"
                    content={
                      <ul>
                        <li className='mobile'>APAAR ID is not available or doesn’t match with the one uploaded by the college.</li>
                        <li className='mobile'>Aadhaar number is not available or doesn’t match with the one uploaded by the college.</li>
                        <li className='mobile'>Date of birth doesn't match the one provided during the admission process.</li>
                        <li className='mobile'>Incorrect email ID.</li>
                      </ul>
                    }
                  /> */}

                  <InstructionItem
                    className='mobile'
                    id="abbreviations"
                    title="5. Abbreviations used"
                    content={
                      <ul className="list-unstyled mobile">
                        <li><strong>DSC:</strong> Discipline Specific Core courses</li>
                        <li><strong>MDC:</strong> Multi-Disciplinary Courses</li>
                        <li><strong>AEC:</strong> Ability Enhancement Courses</li>
                        <li><strong>SEC:</strong> Skill Enhancement Courses</li>
                        <li><strong>VAC:</strong> Value Addition Courses</li>
                      </ul>
                    }
                  />

                </div>
              </div>
            </div>
          </div>
        </div>

      </StudentTemplate>
    </>
  );
};

const InstructionItem = ({ id, title, content }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };
  return (
    <div className="accordion-item">
      <h2 className="accordion-header" id={`heading${id}`}>
        <button
          className="accordion-button collapsed"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target={`#collapse${id}`}
          aria-expanded={isOpen}
          aria-controls={`collapse${id}`}
          onClick={toggleAccordion}
          style={{
            fontWeight: 'bold',
            fontSize: '1.1rem',
            backgroundColor: '#f8f9fa',
            color: '#333',
            borderBottom: '1px solid #dee2e6',
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          {title}
          <span className="ms-auto">
            <i className={`bi ${isOpen ? 'bi-chevron-up' : 'bi-chevron-down'} svg-color`}></i>
          </span>
        </button>
      </h2>
      <div
        id={`collapse${id}`}
        className={`accordion-collapse collapse ${isOpen ? 'show' : ''}`}
        aria-labelledby={`heading${id}`}
        data-bs-parent="#instructionsAccordion"
      >
        <div
          className="accordion-body"
          style={{
            padding: '15px',
            backgroundColor: '#fff',
            borderLeft: '4px solid #0275d8',
            borderRadius: '4px',
            fontSize: '1rem',
            lineHeight: '1.7',
            color: '#495057',
            fontFamily: 'Georgia, serif',
          }}
        >
          {content}
        </div>
      </div>
    </div>
  );
};


export default StudentHelp;
